module.exports = __webpack_public_path__ + "img/gfwx20220915.cdf5d104.jpg";